import { UseFormReturn, useFieldArray } from 'react-hook-form';

import { Flex } from 'components/layout';
import { useServiceFeatures } from 'hooks/useServiceContext';

import { LTLAccessorial, QuickQuoteInputs } from '../../types';
import { AccessorialsSection } from './AccessorialsSection';
import { CommentsAndSpecialInstructionsSection } from './CommentsAndSpecialInstructionsSection';
import { CommoditySection } from './CommoditySection';
import { ItemsSection } from './ItemsSection';
import { OtherConstraintsSection } from './OtherConstraintsSection';
import { QuoteInformationSection } from './QuoteInformationSection';
import { RateInformationSection } from './RateInformationSection';
import { ShipmentTotalsSection } from './ShipmentTotalsSection';
import { StopsSection } from './StopsSection';
import { WhatAreYouShippingSection } from './WhatAreYouShippingSection';

export interface UnifiedThreeGLTLFormProps {
  formMethods: UseFormReturn<QuickQuoteInputs, any, QuickQuoteInputs>;
  hasAddedQuoteDates: boolean;
  accessorials: LTLAccessorial[];
  isLoadingAccessorials?: boolean;
}

export function UnifiedThreeGLTLForm({
  formMethods,
  hasAddedQuoteDates,
  accessorials,
  isLoadingAccessorials = false,
}: UnifiedThreeGLTLFormProps) {
  const { quickQuoteConfig } = useServiceFeatures();
  const showConstraintSection = !quickQuoteConfig?.hideConstraintSection;

  const itemFieldArray = useFieldArray({
    control: formMethods.control,
    name: 'ltl.items',
    rules: {
      required: 'At least one item is required',
    },
  });

  return (
    <Flex direction='col' gap='lg' className='w-full'>
      <QuoteInformationSection formMethods={formMethods} />
      <StopsSection
        formMethods={formMethods}
        hasAddedQuoteDates={hasAddedQuoteDates}
      />
      <CommoditySection
        formMethods={formMethods}
        replaceItems={itemFieldArray.replace}
      />
      <WhatAreYouShippingSection formMethods={formMethods} />
      <ItemsSection formMethods={formMethods} itemFieldArray={itemFieldArray} />
      <ShipmentTotalsSection formMethods={formMethods} />
      <CommentsAndSpecialInstructionsSection formMethods={formMethods} />
      {showConstraintSection && (
        <OtherConstraintsSection formMethods={formMethods} />
      )}
      <RateInformationSection
        formMethods={formMethods}
        accessorials={accessorials}
      />
      <AccessorialsSection
        formMethods={formMethods}
        accessorials={accessorials}
        isLoading={isLoadingAccessorials}
      />
    </Flex>
  );
}
